import { Component, OnInit, EventEmitter, Output, Input, HostListener, OnChanges } from '@angular/core';

@Component({
  selector: 'navaar-dis-like-icon',
  template: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.285" height="16" viewBox="0 0 18.285 16">
  <g id="_2087973" data-name="2087973" opacity="0.499">
    <path id="Path_2954" data-name="Path 2954" d="M4,9V1A1,1,0,0,0,3,0H0V10H3A1,1,0,0,0,4,9Z" transform="translate(14.285)" [attr.fill]="color"/>
    <path id="Path_2955" data-name="Path 2955" d="M2.23,10.315H5.8a.6.6,0,0,1,.521.282.537.537,0,0,1,.008.567L5.069,13.307a1.619,1.619,0,0,0-.078,1.514,1.773,1.773,0,0,0,1.223.981l.887.21a.624.624,0,0,0,.6-.172l4.816-5.062a2.771,2.771,0,0,0,.774-1.911V2.887A2.945,2.945,0,0,0,10.266.03H4.258a3,3,0,0,0-2.912,2.1L.057,7.73A2.017,2.017,0,0,0,0,8.2a2.176,2.176,0,0,0,2.23,2.11Z" transform="translate(0 -0.03)" [attr.fill]="color"/>
  </g>
</svg>
`,
  styles: [`
      :host(){
        vertical-align: -3px;
      }
  `]
})
export class DisLikeIconComponent implements OnInit, OnChanges {
  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if (changes.isLike && !changes.isLike.firstChange) {
      this.changeColor(changes.isLike.currentValue);
    }
  }
  @HostListener('click')
  public onClickEv() {
    this.clicked.emit();
  }
  @Input('is-dislike-from-user') public isLike: boolean;
  @Output('onClick') public clicked: EventEmitter<any> = new EventEmitter<any>();

  public color: string;
  constructor() { }

  ngOnInit(): void {
    this.changeColor(this.isLike);
  }
  private changeColor(state: boolean) {
    this.color = state ? '#B9025E' : '#adadad';
  }
}
